<script>
import { renderFieldHint } from '@/plugins/fieldHints'

// The info icon + tooltip of a field label that is not a Vuetify field label (a custom label above
// an image editor, a group title): the same icon the labelled fields get from their `hint`.
export default {
    functional: true,
    props: {
        hint: {
            type: String,
            default: null,
        },
    },
    render(h, { props }) {
        return props.hint ? renderFieldHint(h, props.hint) : null
    },
}
</script>
